export default __webpack_public_path__ + "static/media/news2.1d684c38.png";